import qs from "qs";
import createAxiosClient from "./AxiosClient";
import { HttpService } from "./HttpService";
import {
  EncodeType,
  HttpQuery,
  HttpRequestConfig,
  HttpResponse,
} from "./types";

export class ApiService implements HttpService {
  private client;

  constructor(baseURL: string) {
    this.client = createAxiosClient(baseURL);
  }

  static ContentTypes: Record<EncodeType, string> = {
    formData: "multipart/form-data",
    urlEncoded: "application/x-www-form-urlencoded",
    json: "application/json",
  };

  private handleHeaders = (config?: HttpRequestConfig) => {
    return {
      "Content-Type": ApiService.ContentTypes[config?.encodeType || "json"],
      ...config?.headers,
    };
  };

  get<T>(
    url: string,
    query?: HttpQuery,
    config?: HttpRequestConfig
  ): Promise<HttpResponse<T>> {
    url = query ? `${url}?${qs.stringify(query)}` : url;
    return this.client.get<T>(url, {
      headers: this.handleHeaders(config),
    });
  }

  post<T, D>(
    url: string,
    data: D,
    config?: HttpRequestConfig
  ): Promise<HttpResponse<T>> {
    return this.client.post<T>(url, data, {
      headers: this.handleHeaders(config),
    });
  }

  put<T, D>(
    url: string,
    data: D,
    config?: HttpRequestConfig
  ): Promise<HttpResponse<T>> {
    return this.client.put<T>(url, data, {
      headers: this.handleHeaders(config),
    });
  }

  delete<T>(url: string, config?: HttpRequestConfig): Promise<HttpResponse<T>> {
    return this.client.delete<T>(url, {
      headers: this.handleHeaders(config),
    });
  }
}
